<template>
  <div class="modal" id="Modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div id="ModalContent" class="modal__content modal__content--md">
        <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
          <h2 class="font-medium text-base mr-auto">
              {{socialreason.name}}
          </h2>
          <button type="button" class="close" @click="$emit('closeModal')"><span aria-hidden="true">×</span></button>
        </div>
        <div class="overflow-x-auto">
          <table class="table">
            <thead>
              <tr class="border-b dark:border-dark-5">
                <th class="whitespace-nowrap text-center">MONEDA</th>
                <th class="whitespace-nowrap text-center">1 DOLAR EQUIVALE A</th>
                <th class="whitespace-nowrap text-center">MES</th>
                <th class="whitespace-nowrap text-center">AÑO</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!socialreason.trm_change.length">
                <th colspan="4" class="text-center">No hay Elementos seleccionados</th>
              </tr>
              <tr v-for="(item, index) in socialreason.trm_change" :key="`${item}${index}-budget-item`" class="border-b dark:border-dark-5">
                <td class="text-center">
                    <div>
                      {{socialreason.money_code}}
                    </div>
                </td>
                <td class="text-center">
                    <div>
                      {{item.change}}
                    </div>
                </td>
                <td class="text-center">
                    <div>
                      {{item.month}}
                    </div>
                </td>
                <td class="text-center">
                    <div>
                      {{item.year}}
                    </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  </div>
</template>

<script>
  import Loading from '@/components/admin/partials/LoadingWhite'
	import { mapGetters, mapActions } from 'vuex'

	export default {
    name: 'TrmChangeModal',
    props: ['socialreason', 'message'],
    data() {
      return {
        errors: [],
        change: {
          social_reason_id: null,
          change: null,
          entity: 'trmchange'
        },
      }
    },
    async beforeMount () {
      document.body.className = 'overflow-hidden';
    },
    beforeDestroy() {
      document.body.classList.remove('overflow-hidden');
    },
    methods: {
      updateTrmChange () {
        let vm = this
        vm.change.social_reason_id = this.socialreason.id
        vm.loading = false
        vm.store(vm.change).then(item => {
          vm.boxedit = false
          window.location.reload()
        })
        .catch(message => {
          console.log(message)
        })
        .finally(() => {
          vm.loading = true
        })
      },
      ...mapActions([
        'store',
      ])
    },
    components: {
      appLoading: Loading,
    }
	}
</script>

<style>
  #Modal {
    visibility: initial;
    opacity: unset;
    z-index: 100000000000;
    margin: unset;
    display: flex
  }

  #ModalContent {
    margin-top: auto;
    margin-bottom: auto
  }
</style>



// WEBPACK FOOTER //
// TrmChangeHistoryModal.vue?0d512c50